import React from 'react';
import { PanelContent, PanelHeader } from '@deque/cauldron-react';
import styles from './WalkthroughContent.css';

interface Props {
  title: React.ReactNode;
  content: React.ReactNode;
  statusMessage: React.ReactNode;
  active: boolean;
}

const WalkthroughContent: React.FC<Props> = ({
  title,
  content,
  statusMessage,
  active
}) => {
  if (!active) {
    return null;
  }

  return (
    <>
      <PanelHeader>
        <h2 className={styles.walkthroughHeading}>{title}</h2>
      </PanelHeader>
      <PanelContent className={styles.panelContent}>
        {content}
        <div className={styles.statusMessage} role="status">
          {statusMessage}
        </div>
      </PanelContent>
    </>
  );
};

export default WalkthroughContent;
